import React from 'react';
import {
  phaserSelector,
  type PhaserSliceState,
} from '@root/store/slices/phaserSlice';
import { useTypedSelector } from '@root/store/store';
import { useImageUrl } from '@shared/components/ImageContext';
import { useTranslation } from 'react-i18next';
import styles from './LoaderScreen.module.scss';

const LOGO_KEY = 'Logo';

const LoaderScreen: React.FC = () => {
  const { t } = useTranslation();
  const { sceneReady, loadProgress, loadError } =
    useTypedSelector<PhaserSliceState>(phaserSelector);
  const { img, imgProps } = useImageUrl();

  if (sceneReady === 'Level') return null;

  const percent = Math.round(loadProgress * 100);

  return (
    <div className={styles.container}>
      <img
        {...imgProps(LOGO_KEY)}
        alt="Ludo Last Mile"
        className={styles.logo}
      />

      <div className={styles.content}>
        {loadError ? (
          <>
            <p className={styles.headline}>{t('Couldn’t load the game')}</p>
            <p className={styles.message}>
              {t(
                'Check your connection and try again. No roll has been charged.'
              )}
            </p>
            <button
              type="button"
              className={styles.retry}
              style={
                {
                  '--button-skin': `url(${img('ButtonSkin_Primary')})`,
                } as React.CSSProperties
              }
              onClick={() => window.location.reload()}
            >
              {t('RETRY')}
            </button>
          </>
        ) : (
          <>
            <p className={styles.headline}>{t('Getting your board ready…')}</p>
            <div className={styles.barTrack}>
              <div
                className={styles.barFill}
                style={{ width: `${percent}%` }}
              />
            </div>
            <p className={styles.percent}>{t('{{percent}}%', { percent })}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default LoaderScreen;
